var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-crud',{attrs:{"crudName":"Status de Chamados","newText":"Novo Status","table":_vm.table,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableEdit":true,"enableDelete":true,"enableView":false,"dataForm":_vm.dataForm,"extra":_vm.extra,"toadd":_vm.toadd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }